var ContestantStates;
(function (ContestantStates) {
    ContestantStates["SignedUp"] = "signed_up";
    ContestantStates["CheckedIn"] = "checked_in";
    ContestantStates["SignUpPending"] = "sign_up_pending";
    ContestantStates["Playing"] = "playing";
    ContestantStates["Finished"] = "finished";
})(ContestantStates || (ContestantStates = {}));

// @TODO: idProvider typings + Enum

// Meta Data

/**
 * League Type
 */
var LeagueTypes;
(function (LeagueTypes) {
    LeagueTypes["Cup"] = "cup";
    LeagueTypes["Swiss"] = "swiss";
    LeagueTypes["FFA"] = "ffa";
    LeagueTypes["Premiership"] = "premiership";
    LeagueTypes["Ladder"] = "ladder";
    LeagueTypes["ASeries"] = "a-series";
})(LeagueTypes || (LeagueTypes = {}));
/**
 * League State
 */
var LeagueStates;
(function (LeagueStates) {
    LeagueStates["Setup"] = "setup";
    LeagueStates["PreSignUp"] = "preSignUp";
    LeagueStates["LateSignUp"] = "lateSignUp";
    LeagueStates["CheckIn"] = "checkIn";
    LeagueStates["InProgress"] = "inProgress";
    LeagueStates["Finished"] = "finished";
})(LeagueStates || (LeagueStates = {}));
/**
 * League Contestant Type
 */
var LeagueContestantTypes;
(function (LeagueContestantTypes) {
    LeagueContestantTypes["Player"] = "player";
    LeagueContestantTypes["Team"] = "team";
})(LeagueContestantTypes || (LeagueContestantTypes = {}));
/**
 * SkillLevel
 */
var LeagueSkillLevels;
(function (LeagueSkillLevels) {
    LeagueSkillLevels["Pro"] = "pro";
    LeagueSkillLevels["Open"] = "open";
    LeagueSkillLevels["Major"] = "major";
    LeagueSkillLevels["ProQualifier"] = "pro-qualifier";
})(LeagueSkillLevels || (LeagueSkillLevels = {}));
/**
 * EnabledFeatures
 */
var LeagueEnabledFeatures;
(function (LeagueEnabledFeatures) {
    LeagueEnabledFeatures["Roster"] = "roster";
    LeagueEnabledFeatures["AC2"] = "ac2";
})(LeagueEnabledFeatures || (LeagueEnabledFeatures = {}));
var LeagueNamespaceTypesEnum;
(function (LeagueNamespaceTypesEnum) {
    LeagueNamespaceTypesEnum["prizes"] = "prizes";
    LeagueNamespaceTypesEnum["sponsor"] = "sponsor";
    LeagueNamespaceTypesEnum["chatinfo"] = "chatinfo";
    LeagueNamespaceTypesEnum["quickrules"] = "quickrules";
    LeagueNamespaceTypesEnum["help"] = "help";
    LeagueNamespaceTypesEnum["coverage"] = "coverage";
    LeagueNamespaceTypesEnum["gamerules"] = "gamerules";
    LeagueNamespaceTypesEnum["systemrules"] = "systemrules";
    LeagueNamespaceTypesEnum["generalrules"] = "generalrules";
})(LeagueNamespaceTypesEnum || (LeagueNamespaceTypesEnum = {}));

var MatchStates;
(function (MatchStates) {
    MatchStates["Challenge"] = "challenge";
    MatchStates["Open"] = "open";
    MatchStates["Deleted"] = "deleted";
    MatchStates["Exception"] = "exception";
    MatchStates["Protest"] = "protest";
    MatchStates["Closed"] = "closed";
})(MatchStates || (MatchStates = {}));

// Api typings needed when sending data
var ApiTeamMemberRoles;
(function (ApiTeamMemberRoles) {
    ApiTeamMemberRoles["TeamOwner"] = "Team-Owner";
    ApiTeamMemberRoles["TeamManager"] = "Team-Manager";
    ApiTeamMemberRoles["TeamCaptain"] = "Team-Captain";
    ApiTeamMemberRoles["Orga"] = "Orga";
    // eslint-disable-next-line @typescript-eslint/no-shadow
    ApiTeamMemberRoles["Player"] = "Player";
    ApiTeamMemberRoles["Trial"] = "Trial";
    ApiTeamMemberRoles["HonoraryMember"] = "Honorary member";
    ApiTeamMemberRoles["Inactive"] = "Inactive";
})(ApiTeamMemberRoles || (ApiTeamMemberRoles = {}));
var ApiTeamMemberPermissions;
(function (ApiTeamMemberPermissions) {
    ApiTeamMemberPermissions["Leader"] = "leader";
    ApiTeamMemberPermissions["CoLeader"] = "co-leader";
    ApiTeamMemberPermissions["MatchOrga"] = "matchorga";
    ApiTeamMemberPermissions["Fighter"] = "fighter";
    ApiTeamMemberPermissions["Trial"] = "trial";
})(ApiTeamMemberPermissions || (ApiTeamMemberPermissions = {}));
// API Matcher
const teamMemberRoleMatcher = Object.freeze({
    team_owner: "Team-Owner",
    team_manager: "Team-Manager",
    team_captain: "Team-Captain",
    orga: "Orga",
    player: "Player",
    trial: "Trial",
    honorary_member: "Honorary member",
    inactive: "Inactive",
});
const teamMemberPermissionMatcher = Object.freeze({
    leader: "leader",
    co_leader: "co-leader",
    matchorga: "matchorga",
    fighter: "fighter",
    trial: "trial",
});

var Genders;
(function (Genders) {
    Genders["MALE"] = "male";
    Genders["FEMALE"] = "female";
})(Genders || (Genders = {}));

/*
 * Public API Surface of api-typings
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiTeamMemberPermissions, ApiTeamMemberRoles, ContestantStates, Genders, LeagueContestantTypes, LeagueEnabledFeatures, LeagueNamespaceTypesEnum, LeagueSkillLevels, LeagueStates, LeagueTypes, MatchStates, teamMemberPermissionMatcher, teamMemberRoleMatcher };
//# sourceMappingURL=play-api-typings.js.map
